import { KeyboardArrowDown } from '@mui/icons-material';

function ExpandMoreIcon({show = true, color = "#2F2F41"}) {
    return (
        <div className={"expand-wrp " + (show ? "" : "hide")}>
            <KeyboardArrowDown sx={{ color: color}} fontSize="large"></KeyboardArrowDown>
        </div>
    );
}

export default ExpandMoreIcon;